export const config ={

	fbAppId:'1647931441989910',
    baseUrl: '/mepa-api/app/v1',
    //baseUrl: `http://sl73pwewbd001.visa.com:8081/mepa-api/app/v1`,
    shareUrl:`staging.promotions.visa.com/mepa-api/web/v1/shareFB?shareObjectId=`,
}
 




// WEBPACK FOOTER //
// ./src/config.js